<template>
  <div class="v-pass-strength" :class="modifierClass">
    <slot></slot>
    <div class="v-pass-strength__bar">
      <div class="v-pass-strength__bar-inner"></div>
    </div>
    <div class="v-pass-strength__text v-pass-strength__text--poor">{{loc('passStrength.weak')}}</div>
    <div class="v-pass-strength__text v-pass-strength__text--weak">{{loc('passStrength.weak')}}</div>
    <div class="v-pass-strength__text v-pass-strength__text--good">{{loc('passStrength.good')}}</div>
    <div class="v-pass-strength__text v-pass-strength__text--strong">{{loc('passStrength.strong')}}</div>
  </div>
</template>

<script>

export default {
  name: 'VPassStrength',
  props: ['password'],
  computed: {
    // If you change how password scoring works, implement changes to server side also!
    passwordScore() {
      const PASSWORD_MIN_LENGTH = 8;
      const PASSWORD_MIN_STRENGTH = 60;
      const pass = this.password;

      let score = 0;

      // award every unique letter until 5 repetitions
      let letters = {};

      for (let i = 0; i < pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 5.0 / letters[pass[i]];
      }

      // bonus points for mixing it up
      let variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass)
      };

      let variationCount = 0;
      for (let check in variations) {
        variationCount += (variations[check] === true) ? 1 : 0;
      }
      score += (variationCount - 1) * 10;

      // If length is below limit, reduce points
      if (pass.length <= PASSWORD_MIN_LENGTH) {
        score = score * (pass.length / PASSWORD_MIN_LENGTH);
      }

      return score;
    },
    modifierClass() {
      const score = this.passwordScore;

      if (score > 80) {
        return 'is-strong';
      }

      if (score > 60) {
        return 'is-good';
      }

      if (score >= 30) {
        return 'is-weak';
      }

      if (score > 0) {
        return 'is-poor';
      }
    }
  }
}
</script>

<style>

</style>


